import { useState } from "react";
import { Modal, Form, Col, Row, NavLink } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { exampleCsv, importCsv } from "../api";
import { fileLink } from "../statisticsview/statements/filelink";
import { getAllCoursesForPersons } from "../actions/competences/courses/coursesgetallforpersons";
import { useDispatch } from "react-redux";
import { getAllEducationsForPersons } from "../actions/competences/educations/educationsgetallforpersons";
import { getAllSkillsForPersons } from "../actions/competences/skills/skillsgetallforpersons";
import { getAllLanguagesForPersons } from "../actions/competences/languages/languagesgetallforpersons";
import Loading from "./loaders/loading";
import { Button } from "./Button.tsx";

let dragCounter = 0;
const dragClass = "dragOutline";
const dragOver = (e) => e.preventDefault();
const dragEnter = (e) => {
  if (dragCounter === 0) e.currentTarget.classList.add(dragClass);
  ++dragCounter;
};
const dragLeave = (e) => {
  if (--dragCounter === 0) {
    e.currentTarget.classList.remove(dragClass);
  }
};

const drop = (e) => {
  e.preventDefault();
  e.currentTarget.classList.remove(dragClass);
  dragCounter = 0;
  e.currentTarget.elements[0].files = e.dataTransfer.files; // populate the file input
  e.currentTarget.requestSubmit();
};

export function ImportCsvModal({ hideModal }) {
  const { t } = useTranslation();
  const [result, setResult] = useState({});

  return (
    <Modal show onHide={hideModal} backdrop="static" size="xl" fullscreen="lg-down">
      <Modal.Header closeButton>
        <Modal.Title>{t("CsvFileImport", "CSV tiedostotuonti")}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ height: "50vh" }}>
        <h4>Osaaminen</h4>
        <Row className="csvImport">
          {CsvImport({ section: "educations", title: "Tutkinnot", setResult })}
          {CsvImport({ section: "courses", title: "Muut koulutukset", setResult })}
          {CsvImport({ section: "skills", title: "Taidot", setResult })}
          {CsvImport({ section: "languageSkills", title: "Kielitaidot", setResult })}
        </Row>
        {result.error && <p style={{ color: "red", marginTop: "1em" }}>{result.error}</p>}
        {result.success && <p style={{ color: "green", marginTop: "1em" }}>{result.success}</p>}
      </Modal.Body>

      <Modal.Footer style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button variant="cancel" onClick={hideModal}>
          {t("Close", "Sulje")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function CsvImport({ section, title, setResult }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <Col>
      <Form
        onDragOver={dragOver}
        onDragEnter={dragEnter}
        onDragLeave={dragLeave}
        onSubmit={async (e) => {
          e.preventDefault();
          setResult({ success: <Loading show={true} /> });
          const file = new FormData(e.target).get("csv");
          try {
            const response = await importCsv(section, await file.text());
            setResult({
              success: `${response.data.created.length} ${section} created, ${response.data.updated.length} updated, errors: ${response.data.errors ?? 0}`,
            });
            switch (section) {
              case "educations":
                dispatch(getAllEducationsForPersons());
                break;
              case "courses":
                dispatch(getAllCoursesForPersons());
                break;
              case "skills":
                dispatch(getAllSkillsForPersons());
                break;
              case "languageSkills":
                dispatch(getAllLanguagesForPersons());
                break;
            }
          } catch ({ response }) {
            setResult({ error: response.data.message });
          }
        }}
        onDrop={drop}
      >
        <p>
          <b>{title}</b>
        </p>
        <p>
          <NavLink onClick={() => fileLink(exampleCsv(section), `example_${section}.csv`)} style={{ textDecoration: "underline" }}>CSV-esimerkki</NavLink>
        </p>
        <p>Pudota CSV-tiedosto tähän tai avaa valintaikkuna alapuolelta</p>
        <input
          type="file"
          style={{ display: "none" }}
          name="csv"
          accept=".csv"
          onInput={(e) => e.target.form.requestSubmit()}
        />
        <Button
          variant="success"
          onClick={(e) => {
            e.target.parentElement.classList.add(dragClass); // form
            e.target.parentElement.elements[0].click(); // file input
            const focusEvent = "focus";
            const removeDragClass = () => {
              window.removeEventListener(focusEvent, removeDragClass);
              e.target.parentElement.classList.remove(dragClass);
            };
            window.addEventListener(focusEvent, removeDragClass);
          }}
        >
          {t("SelectFile", "Valitse tiedosto")}
        </Button>
      </Form>
    </Col>
  );
}
